import styled from "styled-components";
import { TextField } from "@mui/material";

export const StyledTextField = styled(TextField).attrs({
  size: "small",
})`
  width: 100%;
`;
